import { FieldProps, useFormikContext } from "formik";
import React, { useEffect, useState, useCallback } from "react";
import { debounce, isString } from "lodash";

export interface RemoteValidateInputProps {
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	id: string;
	name: string;
	onKeyPress?: (e: React.KeyboardEvent) => void;
	ref?: React.RefObject<any>;
	value?: string;
	[key: string]: any;
	editInline?: boolean;
	className?: string;
	fieldId: string;
	remoteValidate: (fieldId: string, value: string, setRemoteData: (data: string | boolean) => void) => void;
}

const RemoteValidateInput: React.FC<RemoteValidateInputProps> = ({
	field,
	form,
	className,
	editInline,
	id,
	name,
	remoteValidate,
	fieldId,
	...props
}) => {
	const [response, setResponse] = useState<string | boolean>("");

	const formikContext = useFormikContext();

	const debouncedValidate = useCallback(
		debounce((input: string) => {
			remoteValidate(fieldId, input, setResponse);
		}, 600),
		[]
	);

	useEffect(() => {
		if (response !== true) {
			const errorValue = isString(response) ? response : "Invalid Field Value";
			form?.setStatus({ ...form?.status, [fieldId]: errorValue });
		} else {
			form?.setStatus({ ...form?.status, [fieldId]: null });
		}
	}, [response]);

	useEffect(() => {
		if (formikContext.validationSchema?.fields?.hasOwnProperty(fieldId)) {
			form?.validateField(fieldId);
		}
	}, [form?.status?.[fieldId]]);

	return (
		<input
			id={id}
			type="text"
			{...field}
			name={(field && field.name) || name}
			value={(field && field.value) || props.value}
			className={`${className ? className : ""}${editInline ? "edit-inline" : ""}`}
			{...props}
			onInput={(e) => debouncedValidate(e.currentTarget.value)}
		/>
	);
};

export default RemoteValidateInput;
